export const apiOptionsProduction = {
    onTheLiveNDP: {
        // token_auth: "????",
        apiServerUrl: "https://apis.neolab.net",
        clientId: "mlk4v2bgmkk0tn6ijjmkfio8afa55ut4@paper.neolab.net",
        clientSecret: "zCFtDuiyXqWnzY0aI5JUfOAVlT8K7ZAQ",
        grantType: "client_credentials",
    }
};
//# sourceMappingURL=config_production.js.map